import React from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../components/ui/dialog";
import { useShop } from "../context/ShopContext";
import { inr } from "../lib/api";

export const QuickView = ({ product, open, onOpenChange }) => {
  const { addToCart, setCartOpen } = useShop();
  const discount = product.original_price
    ? Math.round(((product.original_price - product.price) / product.original_price) * 100)
    : 0;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-ivory border-gold/40 rounded-sm max-w-3xl p-0 overflow-hidden" data-testid={`quickview-modal-${product.id}`}>
        <DialogTitle className="sr-only">{product.name}</DialogTitle>
        <div className="grid sm:grid-cols-2">
          <div className="aspect-[3/4] sm:aspect-auto sm:h-full bg-surface">
            <img src={product.images[0]} alt={product.name} className="w-full h-full object-cover" />
          </div>
          <div className="p-6 sm:p-8 flex flex-col">
            <p className="text-[10px] tracking-[0.25em] uppercase text-gold">{product.fabric}</p>
            <h3 className="font-heading text-2xl text-charcoal mt-2">{product.name}</h3>
            <div className="flex items-center gap-1.5 mt-2">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className={`w-3.5 h-3.5 ${i < Math.round(product.rating) ? "fill-gold text-gold" : "text-gold/30"}`} />
              ))}
              <span className="text-xs text-charcoal/50 ml-1">({product.reviews_count})</span>
            </div>
            <div className="flex items-baseline gap-3 mt-4">
              <span className="text-2xl text-maroon font-semibold">{inr(product.price)}</span>
              {product.original_price && <span className="text-charcoal/40 line-through">{inr(product.original_price)}</span>}
              {discount > 0 && <span className="text-xs bg-maroon text-ivory px-2 py-0.5 tracking-wider">-{discount}%</span>}
            </div>
            <p className="text-sm text-charcoal/60 leading-relaxed mt-4 line-clamp-3">{product.description}</p>
            <div className="mt-auto pt-6 space-y-3">
              <button
                onClick={() => { addToCart(product); onOpenChange(false); setCartOpen(true); }}
                data-testid={`quickview-add-btn-${product.id}`}
                className="w-full bg-maroon text-ivory text-xs tracking-[0.18em] uppercase py-3.5 hover:bg-maroon-dark transition-colors"
              >
                Add to Cart
              </button>
              <Link
                to={`/product/${product.id}`}
                onClick={() => onOpenChange(false)}
                data-testid={`quickview-details-link-${product.id}`}
                className="block text-center text-xs tracking-[0.15em] uppercase text-charcoal/60 hover:text-maroon underline underline-offset-4"
              >
                View Full Details
              </Link>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
